<template>
  <div>
    <div class="matching-box clearfix">
      <vxe-form
          :data="formData"
          :rules="formRules"
          title-colon
          ref="xForm"
          title-width="120"
          title-align="right"
      >
        <vxe-form-item title="关联合同" field="contractNum" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              <a @click="openDetail">{{ formData.contractNum }}</a>
            </div>
            <div style="height: 100%;display: flex;align-items: center;padding: 10px" v-else>
              <a v-if="formData.contractNum === null || formData.contractNum === ''" @click="openContract">
                请选择关联合同
              </a>
              <a v-else @click="openContract">
                {{ formData.contractNum }}
              </a>
              <span class="link-other" style="margin-left: 5px;">
                <Icon type="ios-link" @click="openContract"/>
              </span>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="业务类型" field="busType" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              {{ busTypeText }}
            </div>
            <vxe-select
                v-model="formData.busType"
                transfer
                placeholder="请选择"
                @change="changeBusType"
                v-else
            >
              <vxe-option
                  v-for="(item, index) in contractListType"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
              ></vxe-option>
            </vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="托运人名称" field="buyerName" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              <a @click="openUserInfo(formData,'buyer')">{{ formData.buyerName }}</a>
            </div>
            <a
                class="matching-sel-link"
                @click="openUser('buyerName')"
                target="_black"
                v-else
            >{{
                formData.buyerName === null || formData.buyerName === ""
                    ? "请选择客户"
                    : formData.buyerName
              }}
              <Icon
                  type="md-close"
                  @click.stop="clear('buyerName')"
                  v-show="
                !(formData.buyerName === null || formData.buyerName === '')
              "
              />
            </a>
          </template>
        </vxe-form-item>
        <vxe-form-item title="承运人名称" field="sellerName" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              <a @click="openUserInfo(formData,'seller')">{{ formData.sellerName }}</a>
            </div>
            <a
                class="matching-sel-link"
                @click="openUser('sellerName')"
                target="_black"
                v-else
            >{{
                formData.sellerName === null || formData.sellerName === ""
                    ? "请选择客户"
                    : formData.sellerName
              }}
              <Icon
                  type="md-close"
                  @click.stop="clear('sellerName')"
                  v-show="
                !(formData.sellerName === null || formData.sellerName === '')
              "
              />
            </a>
          </template>
        </vxe-form-item>
        <vxe-form-item title="业务员" field="saleMan" span="8">
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.saleMan }}
          </div>
          <div v-else
               style="display: flex;align-items: center;height: 100%;padding: 10px;border-bottom: 1px solid #f2f1f1;">
            <sales-man
                :isEdit="!isSaleMan"
                :row="formData"
                :field="'saleMan'"
                :placeholder="'请选择业务员'"
                @setSaleMan="setSaleMan"
                @focus="clearValidate"
                @blur="clearValidate"
            ></sales-man>
          </div>
        </vxe-form-item>
        <vxe-form-item title="客户经理" field="clientManage" span="8">
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.clientManage }}
          </div>
          <vxe-input v-else class="rowInput" v-model="formData.clientManage" placeholder="自动带入" readonly></vxe-input>
        </vxe-form-item>
        <vxe-form-item title="合同" field="contractFiles" span="24">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              <upload-detail :arrList="formData.contractFiles"></upload-detail>
            </div>
            <div class="matching-inner-box" v-else>
              <upload-list
                  :row="formData"
                  :initFileList="formData.contractFiles"
                  :view="'packup'"
                  ref="uploadlist"
              ></upload-list>
            </div>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <vxe-modal v-model="isShowModal" title="选择账户" width="800" height="600" resize>
      <account-modal :isPer="isPer" @choose="chooseUser" ref="userModel"></account-modal>
    </vxe-modal>
    <vxe-modal v-model="userInfoModal" width="1450" height="800" position="center" title="查看用户信息" destroy-on-close>
      <user-center :userId="editUserId" :userType="userType" :isUserEdit="false" :userName="userName"
                   :salesManName="salesManName" ref="userCenter"></user-center>
    </vxe-modal>
    <vxe-modal v-model="isShowContract" title="关联合同" width="1400" height="600" resize>
      <choose-agreement :isSalesMan="true" @choose="chooseAgreement" ref="agreementModel"></choose-agreement>
    </vxe-modal>
    <vxe-modal v-model="createModal" :title="modalTitle" width="1300" height="400" @close="closeCreate" resize
               position="center">
      <create ref="modalCreate"></create>
    </vxe-modal>
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center" @close="closeDetail"
               resize>
      <contract-detail ref="detailModal" @close="closeDetail"></contract-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
import AccountModal from "@/components/matching/Account";
import UploadDetail from "@/components/common/UploadDetail";
import UserCenter from "@/views/account/UserCenter";
import ContractModal from "@/components/modal/ChooseContract"; //选择合同
import SalesMan from "@/components/common/SalesMan";
import ChooseAgreement from "@/components/order2.0/Agreement/ChooseAgreement";
import Create from "@/components/order2.0/Agreement/CreateModal";
import ContractDetail from "@/views/contracts/contractDetail";
import {apiGet} from "@/utils/api";
import auth from "@/utils/auth";
import {getOrderMatchingType} from "@/apiProvider/other";

export default {
  props: {
    isSubmit: Boolean,
    detailData: Object,
    isDetail: {
      default: false,
      type: Boolean
    },
  },
  components: {
    UploadList,
    AccountModal,
    UploadDetail,
    UserCenter,
    ChooseAgreement,
    SalesMan,
    Create,
    ContractDetail
  },
  data() {
    let userInfoValue = {};
    if (auth.isLogin()) {
      userInfoValue = auth.getAuth();
    }
    return {
      userInfoValue,
      formData: {
        contractNum: null,
        busType: null,
        buyerName: null,
        sellerName: null,
        contractFiles: null
      },
      formRules: {
        busType: [{required: true, message: "请选择业务类型"}],
        buyerName: [{required: true, message: "请选择托运人"}],
        sellerName: [{required: true, message: "请选择承运人"}],
        saleMan: [{required: true, message: "请选择业务员"}]
      },
      contractListType: [],
      isShowContract: false, // 选择合同弹窗
      isShowModal: false,
      busTypeText: null,
      userInfoModal: false,
      userId: null,
      userType: null,
      editUserId: 0,
      userName: null,
      salesManName: null,
      isPer: false,
      isSaleMan: false,
      createModal: false,
      modalTitle: "",
      detailModal: false,
    };
  },
  watch: {
    isSubmit(val) {
      if (val) {
        this.setParams();
      }
    },
    detailData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.formData.contractId = val.contractId;
          this.formData.contractNum = val.contractNum;
          this.formData.busType = val.busType;
          this.formData.buyerName = val.buyerName;
          this.formData.buyerId = val.buyerId;
          this.formData.sellerName = val.sellerName;
          this.formData.sellerId = val.sellerId;
          this.formData.saleMan = val.saleMan;
          this.formData.saleManId = val.saleManId;
          this.formData.clientManage = val.clientManage;
          this.formData.clientManageId = val.clientManageId;
          this.formData.contractFiles = val.contractFileList;
          this.busTypeText = val.busTypeText;
          this.formData.contractCate = val.contractCate;
          this.$emit("bustype", val.busType);
        }
      }
    }
  },
  mounted() {
    this.getDicDate();
    if (!this.isDetail) {
      this.setData();
    }
  },
  methods: {
    openDetail() {
      if (this.formData.contractCate === 2) {
        this.modalTitle = "合同详情";
        this.createModal = true;
        this.$refs.modalCreate.queryContractDetail(this.formData.contractId);
        this.$refs.modalCreate.showDetail();
        this.$refs.modalCreate.orderShow();
      } else if (this.formData.contractCate === 3) {
        this.detailModal = true;
        if (this.formData.contractNum.indexOf('HFP') > -1) {
          this.$refs.detailModal.orderOpen(this.formData.contractId, 1);
        } else {
          this.$refs.detailModal.orderOpen(this.formData.contractId, 2);
        }

      }
    },
    closeDetail() {
      this.detailModal = false;
    },
    closeCreate() {
      this.$refs.modalCreate.close();
    },
    async setData() {
      let userInfo = this.userInfoValue;
      if (userInfo.identityType === 0) {
        this.isSaleMan = true;
        let res = await $api.baseUserSales.request('querySalesDetail', {
          id: userInfo.id
        });
        this.saleMan = userInfo.username;
        if (res.status === 1) {
          this.$set(this.formData, 'saleMan', userInfo.username);
          this.$set(this.formData, 'saleManId', userInfo.id);
          this.$set(this.formData, 'clientManage', res.data.clientManager);
          this.$set(this.formData, 'clientManageId', res.data.clientManagerId);
        }
      } else {
        this.isSaleMan = false;
        this.$set(this.formData, 'saleMan', null);
        this.$set(this.formData, 'saleManId', null);
        this.$set(this.formData, 'clientManage', null);
        this.$set(this.formData, 'clientManageId', null);
      }
    },
    setSaleMan(val) {
      if (val.clientManager) {
        this.$set(this.formData, 'clientManage', val.clientManager);
        this.$set(this.formData, 'clientManageId', val.clientManagerId);
      } else {
        this.$set(this.formData, 'clientManage', null);
        this.$set(this.formData, 'clientManageId', null);
      }
      this.clearValidate();
    },
    //选择合同
    openContract() {
      this.isShowContract = true;
      this.clearValidate();
      this.$nextTick(() => this.$refs.agreementModel.init());
    },
    async chooseAgreement(row, type) {
      if (type === 1) {
        this.formData.contractId = row.id;
        this.formData.contractNum = row.numb;
      } else if (type === 2) {
        this.formData.contractId = row.id;
        this.formData.contractNum = row.contractNum;
        let confirm = await this.$XModal.confirm("是否自动带入合同中的货物和物流信息？");
        let isTakeIn = confirm === "confirm";
        if (isTakeIn) {
          this.$store.commit("order2/CHOOSE_MATCHING_AGREEMENT_OBJ", row);
        }
      } else if (type === 3) {
        this.formData.contractId = row.id;
        this.formData.contractNum = row.contractNum;
        let confirm = await this.$XModal.confirm("是否自动带入合同中的货物和物流信息？");
        let isTakeIn = confirm === "confirm";
        if (isTakeIn) {
          this.$store.commit("order2/CHOOSE_MATCHING_AGREEMENT_OBJ", row);
        }
      }
      this.isShowContract = false;
    },
    async openUserInfo(row, type) {
      let id = type === 'buyer' ? row.buyerId : row.sellerId;
      let res = await apiGet("api/auth/", "baseUserSign/getUserSignById", {
        userId: id,
      });
      if (res.status === 1) {
        this.userType = res.data.userType;
        this.editUserId = id;
        this.userName = type === 'buyer' ? row.buyerName : row.sellerName;
        this.userInfoModal = true;
      } else {
        this.$Modal.error({
          title: "错误提示",
          content: res.message,
        });
      }
    },
    getDicDate() {
      this.contractListType = [];
      $api.other.getOrderMatchingType
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.encoded)
              };
              this.contractListType.push(obj);
            });
          });
    },
    async setParams() {
      const errMap = await this.$refs.xForm.validate().catch(errMap => errMap);
      if (errMap) {
        this.$emit("setParams", false);
        return;
      } else {
        let obj = {
          contractId: this.formData.contractId,
          contractNum: this.formData.contractNum,
          busType: this.formData.busType,
          buyerName: this.formData.buyerName,
          buyerId: this.formData.buyerId,
          sellerName: this.formData.sellerName,
          sellerId: this.formData.sellerId,
          contractFiles: this.formData.fileUuidList,
          saleMan: this.formData.saleMan,
          saleManId: this.formData.saleManId,
          clientManage: this.formData.clientManage,
          clientManageId: this.formData.clientManageId,
        };
        this.$emit("setParams", obj);
      }
    },
    clear(field) {
      this.formData[field] = null;
    },
    clearValidate() {
      this.$refs.xForm.clearValidate();
    },
    changeBusType(val) {
      this.clearValidate();
      this.$emit("bustype", val.value);
    },
    openUser(field) {
      this.isPer = field === 'sellerName';
      this.isShowModal = true;
      this.$nextTick(() => {
        this.$refs.userModel.init(field);
      })
    },
    chooseUser(row, type, field) {
      this.clearValidate();
      if (type === 3) {
        this.formData[field] = row.name;
      } else {
        this.formData[field] = row.userName;
        if (type === 2) {
          this.formData.sellerId = row.id;
        }
      }
      this.isShowModal = false;
    }
  }
};
</script>

<style>
</style>